<template>
  <div class='properties-search'>
    <div class='default-content'>
      <h1 class='section-title'>{{locales.properties && locales.properties.all_properties}}</h1>
      <div class='properties-control'>
        <div class='properties-control__left'>
          <div class='properties-control__terms'>
            <a class='properties-control__terms-item' :class="old.term && old.term ==0 ? 'properties-control__terms-item--active' : (old.term != 0 && old.term != 1 && term === 0 ? 'properties-control__terms-item--active' : '')" href='#' @click.prevent='changeTermValue(0)' data-value="0">{{locales.pages && locales.pages.long_term_rent}}</a>
            <a class='properties-control__terms-item' :class="old.term && old.term ==1 ? 'properties-control__terms-item--active' : (old.term != 0 && term === 1 ? 'properties-control__terms-item--active' : '')" href='#' @click.prevent='changeTermValue(1)' data-value="1">{{locales.pages && locales.pages.short_term_booking}}</a>
          </div>
          <div class='properties-control__distance-select'>
            <select type='text' class='properties-control__distance-select-item' name='ray' @change='changeDistance'>
              <option value='0' :selected="old.ray === '0'">0 km</option>
              <option value='5' :selected="old.ray === '5'">< 5 km</option>
              <option value='10' :selected="old.ray === '10'">< 10 km</option>
              <option value='20' :selected="old.ray === '20'">< 20 km</option>
              <option value='40' :selected="old.ray === '40'">< 40 km</option>
            </select>
          </div>
          <div class='properties-control__filter-btn-desktop'>
            <a class='theme-btn theme-btn--tertiary theme-btn--small' :class="{ 'theme-btn--tertiary--active': showFilters }" @click.stop='toggleFilters'>
              <i class='icon-filter' style='font-size: 25px;'/>
              {{ locales.common && locales.common.filters }}
            </a>
            <span
              v-if='selectedFilters > 0'
              class='properties-control__filter-count'
            >{{selectedFilters}}</span>
          </div>
          <div class='properties-control__filter-btn-mobile'>
            <a class='theme-btn theme-btn--tertiary theme-btn--square--small' :class="{ 'theme-btn--tertiary--active': showFilters }" @click.stop='toggleFilters'>
              <i class='icon-filter' style='font-size: 25px;'/>
            </a>
          </div>
        </div>
        <div class='properties-control__right'>
          <a class='properties-control__switcher' :class="{ 'properties-control__switcher--active': isGrid }" @click.prevent='isGrid ? null : setLayout("grid")'>
            <i class='icon-grid'/>
          </a>
          <a class='properties-control__switcher' :class="{ 'properties-control__switcher--active': isList }" @click.prevent='isList ? null : setLayout("list")'>
            <i class='icon-list'/>
          </a>
          <a class='properties-control__switcher' :class="{ 'properties-control__switcher--active': isMap }" @click.prevent='isMap ? null : setLayout("map")'>
            <i class='icon-map'/>
          </a>
          <div class='theme-order-select ml-auto pl-2.5'>
            <select class='theme-order-select__item' name='order' @change='sort'>
              <option value='published_at_desc' :selected="order === 'published_at_desc'">
                {{ locales && locales.common && locales.common.most_recent }}
              </option>
              <option value='published_at_asc' :selected="order === 'published_at_asc'">
                {{ locales && locales.common && locales.common.oldest_first }}
              </option>
              <option value='location_asc' :selected="order === 'location_asc'">
                {{ locales && locales.common && locales.common.location_a_z }}
              </option>
              <option value='location_desc' :selected="order === 'location_desc'">
                {{ locales && locales.common && locales.common.location_z_a }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if='searchFilters && Object.keys(searchFilters).length' class="filter-tags pt-4">
        <template v-for='(tag, index) in searchFilters'>
          <template v-if="Array.isArray(tag)">
            <template v-for="value in tag">
              <div class="filter-tags__tag">
                <span class="filter-tags__tag-name">{{locales.property && locales.property[index]}}: {{filteringOptions[index] && filteringOptions[index][value] || value}}</span>
                <span class="icon-close filter-tags__tag-close" @click='removeFilterParam(index, tag, value)'/>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="filter-tags__tag">
              <span class="filter-tags__tag-name">{{locales.property && locales.property[index]}}: {{filteringOptions[index] && filteringOptions[index][tag] || tag}}</span>
              <span class="icon-close filter-tags__tag-close" @click='removeFilterParam(index, tag)'/>
            </div>
          </template>
        </template>
        <a class='filter-tags__reset' @click='resetFilters'>
          <i class='icon-replay'/>
          {{locales.common && locales.common.reset_filters}}
        </a>
      </div>
      <form id="propertyFilters" class='properties-filters' v-if='showFilters'>
        <input type="hidden" name="ray" :value="old.ray">
        <input type="hidden" name="order" :value="order">
        <input type="hidden" name="term" :value="old.term">
        <div class='properties-filters__area'>
          <a class='properties-filters__close' @click='toggleFilters'><i class='icon-close'/></a>
          <div class='properties-filters__heading'>
            {{locales.common && locales.common.filters}}
            <a class='properties-filters__reset' @click='resetFilters'>
              <i class='icon-replay'/>
              {{locales.common && locales.common.clear_filters}}
            </a>
          </div>
          <div class='properties-filters__content'>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.type}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :limited='true'
                :options="categories"
                name="category[]"
                :values="old[`category`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.bedrooms}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :limited='true'
                :options="filteringOptions.no_bedrooms"
                name="no_bedrooms[]"
                :values="old[`no_bedrooms`]"
              />
            </div>
            <!-- <div class='properties-filters__category-box'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.neighbourhood}}</h2>
              <theme-select
                :name="'neighbourhood'"
                :options="filteringOptions.neighbourhood"
                value='0'
                :showLabel='false'
              />
            </div> -->
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.location}}</h2>
              <theme-autocomplete
                :showLabel='false'
                v-model='old.location'
                :initial="old['_labels[location]']"
                name='location'
                endpoint='/admin/autocomplete/locations'
                :is-phrase-model='true'
                :resolve='(item) => item.name'
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.delivery}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :options="filteringOptions['furnishing']"
                :name="'furnishing[]'"
                :values="old[`furnishing`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.available_facilities}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :options="filteringOptions.available_facilities"
                name="available_facilities[]"
                :values="old[`available_facilities`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.availability}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :options="filteringOptions.availability"
                name="availability[]"
                :values="old[`availability`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.total_number_of_candidates}}</h2>
              <theme-select
                name="total_candidates"
                :options="filteringOptions.total_candidates"
                :values="old[`total_candidates`]"
                :showLabel='false'
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.gender}}</h2>
              <theme-filter-checkboxes
                :options="filteringOptions.gender"
                name="gender[]"
                :values="old[`gender`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.age}}</h2>
              <theme-input
                :show-label='false'
                :name="'age'"
                v-model="old[`age`]"
              />
            </div>
            <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.tenant_status}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :options="filteringOptions.tenant_status"
                :name="'tenant_status[]'"
                :values="old[`tenant_status`]"
              />
            </div>
            <!-- <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.number_of_roommates}}</h2>
              <theme-select
                name="roommates"
                :options="{'1': '1', '2': '2', '3': '3', '4':'4' }"
                :value="old['roommates']"
                :showLabel='false'
              />
            </div> -->
            <!-- <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.gender_roommates}}</h2>
              <theme-filter-checkboxes
                :options="{ '1': 'Male', '2': 'Female', '3': 'Mixed' }"
                name="roommates-gender[]"
                :values="old['roommates-gender[]']"
              />
            </div> -->
            <!-- <div class='properties-filters__category-box properties-filters__category-box--divider'>
              <h2 class='properties-filters__category-name'>{{locales.property && locales.property.owner_type}}</h2>
              <theme-filter-checkboxes
                :columnDirection='true'
                :options="{ '1': 'Roommate', '2': 'Private owner', '3': 'Real estate agent' }"
                name="owner-type[]"
                :values="old['owner-type[]']"
              />
            </div> -->
          </div>
          <div class='properties-filters__bottom'>
            <button class='theme-btn theme-btn--theme theme-btn--block' type='submit'>
              {{ locales.common && locales.common.search }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import queryString from 'query-string';
  import {mapGetters} from 'vuex';
  import VAutocompletePublic from './../admin/components/VAutocompletePublic';
  import querystring from 'querystring';

  export default {
    components: {
      VAutocompletePublic,
    },
    props: {
      websiteId: {
        default: '',
        type: String,
      },
      filteringOptions: {
        default: () => {},
        type: Object,
      },
    },
    data() {
      return {
        showFilters: false,
        categoryShow: [],
        old: null,
        order: queryString.parse(window.location.search).order,
        searchFilters: null,
        selectedFilters: 0,
      };
    },
    created() {
      var substrStart = location.search.indexOf('?');
      this.old = queryString.parse(location.search.substring(substrStart+1), {arrayFormat: 'bracket'});
      var queryParams = querystring.parse(location.search.substring(substrStart+1));
      var params = {};
      for (const [key, value] of Object.entries(queryParams)) {
        if(key.indexOf('hidden')==-1 && key.indexOf('_labels')==-1 && value !== ''){
            params[key.replace('[]', '')] = value;
        }
      }
      for(const tag in params){
        if(Array.isArray(params[tag])){
          this.selectedFilters = this.selectedFilters + params[tag].length;
        }else{
          this.selectedFilters = this.selectedFilters + 1;
        }
      }
      this.searchFilters = params;
    },
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getPropertiesLayout;
      },
      website: function() {
        if (this.websiteId == 1) {
          return 'athome';
        } else {
          return 'staffhousing';
        }
      },
      categories() {
        return this.$store.getters.getPropertiesCategories;
      },
      isGrid: function() {
        return this.$store.getters.getPropertiesIsGrid;
      },
      isList: function() {
        return this.$store.getters.getPropertiesIsList;
      },
      isMap: function() {
        return this.$store.getters.getPropertiesIsMap;
      },
      term: function() {
        return this.$store.getters.getPropertiesTerm;
      },
    },
    methods: {
      setLayout(layout) {
        this.$store.commit('SET_PROPERTIES_LAYOUT', layout);
      },
      changeDistance(event) {
        let search = queryString.parse(window.location.search);
        search.ray = event.target.value;
        window.location.search = queryString.stringify(search);
      },
      sort(event) {
        let search = queryString.parse(window.location.search);
        search.order = event.target.value;
        window.location.search = queryString.stringify(search);
      },
      resetFilters() {
        window.location.search = '';
      },
      removeFilterParam(keyToRemove, tag, value = null) {
        const matches = keyToRemove.match(/\d+/);
        const indexToRemove = matches ? matches[0] : null;
        // var queryParams = querystring.parse(location.search.substring(substrStart+1));
        // var params = {};
        // for (const [key, value] of Object.entries(queryParams)) {
        //   if(key.indexOf('hidden')==-1 && key.indexOf('_labels')==-1 && value !== ''){
        //       params[key.replace('[]', '')] = value;
        //   }
        // }
        // for(const tag in params){
        //   if(Array.isArray(params[tag])){
        //     this.selectedFilters = this.selectedFilters + params[tag].length;
        //   }else{
        //     this.selectedFilters = this.selectedFilters + 1;
        //   }
        // }
        // this.searchFilters = params;
        let searchParams = queryString.parse(window.location.search);
        if (indexToRemove) {
          const keyWithoutIndex = keyToRemove.replace(/\d+/g, '');
          if (indexToRemove > -1) {
            searchParams[`${keyWithoutIndex}[]`].splice(indexToRemove, 1);
          }
        } else {
          if (searchParams[keyToRemove]) {
            delete searchParams[keyToRemove];
          } else if (searchParams[`${keyToRemove}[]`]) {
            if(value){
              var index = searchParams[`${keyToRemove}[]`].indexOf(value);
              searchParams[`${keyToRemove}[]`].splice(index, 1);
            }else{
              delete searchParams[`${keyToRemove}[]`];
            }
          }
        }
        window.location.search = queryString.stringify(searchParams);
      },
      changeTermValue(value) {
        this.$store.commit('SET_PROPERTIES_TERM_VALUE', value);
        let search = queryString.parse(window.location.search);
        search.term = event.target.getAttribute("data-value");
        window.location.search = queryString.stringify(search);
      },
      toggleFilters() {
        this.showFilters = !this.showFilters;
        document.body.style.overflow = this.showFilters ? "hidden" : "auto";
      }
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/PropertySearchControl.vue